import { render, staticRenderFns } from "./CreateTestUser.vue?vue&type=template&id=01036832&"
import script from "./CreateTestUser.vue?vue&type=script&lang=ts&"
export * from "./CreateTestUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports